import { Box, Button, Typography } from "@mui/material";
import Alert from "components/alert";
import { setLoading } from "lib/Reducer/loadingSlice";
import { useState } from "react";
import { CgTrashEmpty } from "react-icons/cg";
import { MdRestore } from "react-icons/md";
import { useDispatch } from "react-redux";
import { knowledgeBulkAction } from "../api/knowledge";

const BulkActions = ({
  selectedRows,
  setSelectedRows,
  setReload,
  permissions,
}) => {
  const [alert, setAlert] = useState({ status: false, data: null });

  const dispatch = useDispatch();
  const handleBulkAction = async (type, data) => {
    setAlert({ status: false, data: null });
    dispatch(setLoading(true));
    const obj = { selected_ids: selectedRows, action: type };
    obj[type] = data;
    try {
      await knowledgeBulkAction({ body_data: obj });
    } finally {
      dispatch(setLoading(false));
      setSelectedRows([]);
      setReload((pre) => !pre);
    }
  };

  return (
    <Box
      mt="-5px"
      p="10px 20px 10px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "18px",
        backgroundColor: "#e3eefa",
      }}
    >
      {alert?.status && (
        <Alert
          open={alert?.status}
          handleClose={() => setAlert({ status: false, data: null })}
          title="Delete Selected Lead"
          desc="Are you sure you want to delete? Don't worry you will find these leads on Trash Menu"
          buttons={
            <>
              <Button
                onClick={() => {
                  setAlert({ status: false, data: null });
                  setSelectedRows([]);
                }}
              >
                No, keep it
              </Button>
              <Button
                variant="solid"
                onClick={() => handleBulkAction(alert.data)}
              >
                Yes, delete it
              </Button>
            </>
          }
        />
      )}
      <Typography variant="h5">{selectedRows?.length} Selected</Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        {!!permissions?.delete && (
          <Button
            variant="solid"
            onClick={() => setAlert({ status: true, data: "delete" })}
            startIcon={<CgTrashEmpty />}
          >
            Delete Selected
          </Button>
        )}
        {!!permissions?.restore && (
          <Button
            variant="solid"
            onClick={() => handleBulkAction("restore")}
            startIcon={<MdRestore />}
          >
            Restore Selected
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BulkActions;
